import React, { Component } from 'react'
import './Footer.css';
export default class Header extends Component {
    render() {
        return (
            <div className="spacex-footer">
                <p className="space-footer-text">Developed with <span className="spacex-footer-heart">&hearts;</span>  by Sai Sita Ram Vaddavalli</p>
            </div>
        )
    }
}